import { protectedRoute } from "@/utils/routeUtils";

const allowedRoles = [
  "SUPER_ADMIN",
  "isVisaUser",
  "isHRAdmin",
  "isPayrollUser",
];

const billingRoutes = {
  path: "billing",
  title: "module_title.billing",
  sidebarProps: {
    key: "1-16",
    iconSrc: "billing",
    label: "module_title.billing",
    link: "/billing",
    groupingType: "TOOLS",
    order: 16,
    permissions: allowedRoles,
  },
  element: protectedRoute(
    [() => import("@/pages/billing/Billing")],
    allowedRoles
  ),
};

export default billingRoutes;
